import IconLink from './component';

export default IconLink;
